import { CircleAlert, Trash2 } from 'lucide-react';
import { Button, Modal, Spinner, Stack } from 'react-bootstrap';
import { useUserDeleteMutation } from './profileApi';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDeleteEyeTestMutation } from '../Eyetest/eyetestApi';

const DeleteUser = ({ email, setLoading, eyeTest = false }) => {
    console.log(email, 'emailemail');
    console.log(eyeTest, 'emailemail');
    const { t, i18n } = useTranslation();
    const [modalActive, setModalActive] = useState(false);
    const [deleteUser] = useUserDeleteMutation();
    const [deleteEyeTest] = useDeleteEyeTestMutation();
    const [modalLoading, setModalLoading] = useState(false);

    const handleDelete = async () => {
        setModalLoading(true);
        try {
            if (eyeTest) {
                let result = await deleteEyeTest({ eyeTestID: email });
            } else {
                let result = await deleteUser({ email });
            }
            setModalActive(false);
            setLoading(true);
            setModalLoading(false);
        } catch (error) {}
    };

    return (
        <>
            <Button variant="light" onClick={() => setModalActive(true)}>
                <Stack direction="horizontal" gap={1}>
                    <Trash2 width={16} />
                    {/* useUserDeleteMutation */}
                </Stack>
            </Button>
            <Modal show={modalActive} backdrop="static" keyboard={false}>
                <Modal.Body className="text-center">
                    <CircleAlert
                        size={60}
                        className="mb-4 mt-4"
                        color="#f8bb86"
                    />
                    <p>{t('areYouSure')}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setModalActive(false)}
                    >
                        {t('okay')}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleDelete}
                        disabled={modalLoading}
                    >
                        {modalLoading && (
                            <Spinner animation="border" role="status" size="sm">
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </Spinner>
                        )}{' '}
                        {t('submitRequest')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};
export default DeleteUser;
